The monthly (yearly) performance of the index is calculated from previous month
(year) end to current month (year) end.
